import React, { useRef } from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import { ContentCopyRounded } from '@mui/icons-material';
import classNames from 'classnames';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard';
var SupportContentContainer = function (_a) {
    var className = _a.className, content = _a.content, enableCopyContent = _a.enableCopyContent, onCopy = _a.onCopy, contentAsHtml = _a.contentAsHtml, contentClassName = _a.contentClassName;
    var _b = useCopyToClipboard(), copied = _b.copied, copyToClipboard = _b.copyToClipboard;
    var contentAreaRef = useRef(null);
    var isStringContent = typeof content === 'string';
    var handleCopy = function () {
        var element = contentAreaRef.current;
        if (!element)
            return;
        var textContent = element.textContent;
        if (textContent) {
            copyToClipboard(textContent);
            onCopy === null || onCopy === void 0 ? void 0 : onCopy(textContent);
        }
        else {
            onCopy === null || onCopy === void 0 ? void 0 : onCopy();
        }
    };
    if ((typeof content === 'undefined' && typeof contentAsHtml === 'undefined') ||
        (content === null && contentAsHtml === null)) {
        return null;
    }
    return (React.createElement("div", { className: classNames('lfc-flex lfc-gap-4 lfc-items-start', className) },
        React.createElement("img", { src: 'https://ik.imagekit.io/onsnhxjshmp/geebee-emails/speaking-icon.gif?updatedAt=1727164530201', height: 52, width: 52, alt: "speaking-voice-representation" }),
        React.createElement("div", { className: classNames('lfc-p-3 lfc-rounded-lg lfc-border lfc-border-dashed lfc-border-gbTokens-cloud-200 lfc-bg-gbTokens-teal-100 lfc-flex lfc-flex-col lfc-gap-2 lfc-w-full', contentClassName) },
            enableCopyContent ? (React.createElement(Button, { onClick: handleCopy, startIcon: React.createElement(ContentCopyRounded, null), variant: "tertiary", className: classNames('lfc-self-end lfc-text-gbTokens-primary-500 lfc-transition-all lfc-focus:outline-none', {
                    'lfc-bg-gbTokens-success-200 lfc-text-gbTokens-success-500': copied
                }), size: "small" }, copied ? 'Content Copied' : 'Copy Content')) : null,
            React.createElement("div", { ref: contentAreaRef }, contentAsHtml ? (React.createElement("div", { dangerouslySetInnerHTML: { __html: contentAsHtml } })) : isStringContent ? (React.createElement(GBTypography, { variant: "body4", dangerouslySetInnerHTML: { __html: content } })) : (content)))));
};
export default SupportContentContainer;
//# sourceMappingURL=SupportContentContainer.js.map